/** PhaseList.jsx - the phases inside one zone, truncated to PHASE_PREVIEW. */
import { useState } from 'react';
import { GREEN, GREY, GREY_LIGHT, HAIRLINE, INK, INK_SOFT, PHASE_PREVIEW, SUBLABEL } from './theme';
import { signedCount } from './helpers';
import { Leader } from './Primitives';

export function PhaseRow({ phase }) {
  const signed = signedCount(phase);
  const total = phase.total || 0;
  const pct = total ? Math.round((signed / total) * 100) : 0;
  const complete = pct >= 100;
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 7, padding: '4px 0' }}>
      <span
        style={{
          fontSize: 12.5,
          lineHeight: 1.4,
          maxWidth: '64%',
          minWidth: 0,
          color: complete ? INK : INK_SOFT,
          fontWeight: complete ? 600 : 500,
          overflowWrap: 'anywhere',
        }}
      >
        {phase.name}
      </span>
      <Leader />
      <span
        style={{
          width: 40,
          flexShrink: 0,
          textAlign: 'right',
          fontSize: 11.5,
          fontWeight: 700,
          color: complete ? GREEN : GREY,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {signed}/{total}
      </span>
      <span
        style={{
          width: 32,
          flexShrink: 0,
          textAlign: 'right',
          fontSize: 10.5,
          color: GREY_LIGHT,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {pct}%
      </span>
    </div>
  );
}

export function PhaseList({ phases }) {
  const [open, setOpen] = useState(false);
  const collapsible = phases.length > PHASE_PREVIEW + 1;
  const shown = collapsible && !open ? phases.slice(0, PHASE_PREVIEW) : phases;
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ ...SUBLABEL, paddingBottom: 5, borderBottom: '1px solid ' + HAIRLINE }}>Sections</div>
      <div style={{ paddingTop: 3 }}>
        {shown.map((phase, i) => (
          <PhaseRow key={phase.name || i} phase={phase} />
        ))}
      </div>
      {collapsible && (
        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          style={{
            display: 'block',
            width: '100%',
            textAlign: 'left',
            border: 'none',
            background: 'none',
            borderRadius: 0,
            padding: '9px 0',
            minHeight: 34,
            marginTop: 2,
            color: GREEN,
            fontSize: 9.5,
            fontWeight: 800,
            letterSpacing: '1.7px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {open ? '[-] Show fewer sections' : '[+] Show all ' + phases.length + ' sections'}
        </button>
      )}
    </div>
  );
}

/* ------------------------------ sign-off milestones --------------------------- */
